module.exports = __webpack_public_path__ + "static/media/computer-landing-cartoon-stripped.2a6b0f43.jpg";